import { styled } from "@material-ui/styles";
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, Paper, Typography } from "@material-ui/core";
import React, { useMemo } from "react";

import { Copyright } from "../../../components/Copyright";
import { useAuth } from "../context";
import { AuthState } from "../enums";

import { DomainHintAccess } from "./DomainHintAccess";
import { LogoImage } from "./LogoImage";

export function AuthDialog() {
    const { state, msalLogin, msalRedirectHandle, loginErrors } = useAuth();

    const stateElement = useMemo(() => {
        switch (state) {
            case AuthState.DomainHintAccess:
                return (
                    <DomainHintAccess />
                );
            case AuthState.LoggedOut:
                return (<>
                    <Typography>You've been logged out securely.</Typography>
                    <StyledButton
                        color="primary"
                        variant="contained"
                        onClick={() => msalRedirectHandle()}
                    >
                        Back To Login
                    </StyledButton>
                </>);
            case AuthState.Error:
                return (<>
                    {loginErrors.length > 0
                        ? <Typography color="error">{loginErrors[0]}</Typography>
                        : <Typography>Login failed.</Typography>
                    }
                    <StyledButton
                        color="primary"
                        variant="contained"
                        onClick={() => msalLogin()}
                    >
                        Back To Login
                    </StyledButton>
                </>);
            default:
                return (
                    <div>
                        <CircularProgress />
                    </div>
                );
        }
    }, [state, msalLogin, msalRedirectHandle, loginErrors]);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            PaperComponent={StyledPaper}
        >
            <DialogTitle>
                <LogoImage />
            </DialogTitle>

            <StyledDialogContent>
                {stateElement}
            </StyledDialogContent>

            <CopyrightContainer>
                <Copyright />
            </CopyrightContainer>
        </Dialog>
    );
};

const StyledPaper = styled(Paper)({
    padding: "30px 0px 20px 0px",
    maxWidth: "520px",
    minHeight: "228px",
});

const StyledDialogContent = styled(DialogContent)({
    margin: "auto",
    marginTop: "15px",
    marginBottom: "25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
});

const StyledButton = styled(Button)({
    minWidth: "210px"
});

const CopyrightContainer = styled("div")({
    textAlign: "center",
    fontSize: "11px",
});
